import { render, staticRenderFns } from "./ImagePreviewModal.vue?vue&type=template&id=ba76d764&scoped=true&"
import script from "./ImagePreviewModal.vue?vue&type=script&lang=js&"
export * from "./ImagePreviewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba76d764",
  null
  
)

export default component.exports